export const SALES_PERSON_REPORT_ID = 'sales-person';
